import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateCustomLeadOrganisationMutation,
  CreateCustomLeadOrganisationMutationVariables,
  LeadsQuery,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { updateLeadQuery, updateSearchLeadsQuery } from "./update_cache/updateLeadEntityCache";

const CREATE_CUSTOM_LEAD_ORGANISATION_MUTATION = graphql(`
  mutation createCustomLeadOrganisation($leadId: String!, $input: CreateCustomOrganisationInput!) {
    createCustomLeadOrganisation(leadId: $leadId, input: $input) {
      id
      name
    }
  }
`);

export function useCreateCustomLeadOrganisation(
  options?: UseMutationOptions<
    CreateCustomLeadOrganisationMutation,
    unknown,
    CreateCustomLeadOrganisationMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(CREATE_CUSTOM_LEAD_ORGANISATION_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      const newCustomOrg = data.createCustomLeadOrganisation;
      const { leadId } = variables;

      // In the future, the cache logic will need to be updated if we add custom suppliers

      updateLeadQuery(queryClient, leadId, (lead) => ({
        ...lead,
        customBuyers: [...(lead?.customBuyers ?? []), newCustomOrg],
      }));

      const allLeadsQueries = queryClient.getQueryCache().findAll({ queryKey: ["leads"] });
      for (const { queryKey } of allLeadsQueries) {
        const leadsData = queryClient.getQueryData<LeadsQuery>(queryKey);
        if (!leadsData?.leads) continue;
        if (!leadsData.leads.results.some((l) => l.id === leadId)) continue;
        updateSearchLeadsQuery(queryClient, queryKey, [leadId], (lead) => ({
          ...lead,
          customBuyers: [...(lead.customBuyers ?? []), newCustomOrg],
        }));
      }

      await options?.onSuccess?.(data, variables, context);
    },
  });
}
